module.exports = __webpack_public_path__ + "img/undraw_void.5fe382c1.svg";